import * as h2Api from '../h2Api'

export const SELECT_FACE_TYPE = 'SELECT_FACE_TYPE'
export const SELECT_SKIN_TYPE = 'SELECT_SKIN_TYPE'
export const SELECT_HAIR_TYPE = 'SELECT_HAIR_TYPE'
export const SAVE_AVATAR = 'EARLY_SAVE_AVATAR'

export const changeFaceType = typeId => dispatch => {
  return dispatch({ type: SELECT_FACE_TYPE, faceType: typeId })
}

export const changeSkinType = colorId => dispatch => {
  return dispatch({ type: SELECT_SKIN_TYPE, skinType: colorId })
}

export const changeHairType = colorId => dispatch => {
  return dispatch({ type: SELECT_HAIR_TYPE, hairType: colorId })
}

export const saveAvatar = () => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId
  const avatar = getState().early.avatar

  return dispatch(
    h2Api.put(`/early/${loadedGameId}/avatar`, avatar)({ type: SAVE_AVATAR })
  )
}
